import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';

import { translate } from 'helpers/intl';
import messages from 'containers/AutoDetailsPage/messages';
import { StyledGrid } from 'containers/AutoDetailsPage/SuivreSinistreTab/EmptyItemSinistre/styles';
import ItemEmptyState from 'components/ItemEmptyState';

const EmptyItemSinitre = (props: { intl: IntlShape }) => {
  return (
    <StyledGrid
      container
      textAlign="center"
      alignItems="center"
      justify="center"
      marginBottom="17px"
    >
      <ItemEmptyState
        label={translate({ ...messages.title_sinistre_empty_state }, props)}
      />
    </StyledGrid>
  );
};
export default injectIntl(EmptyItemSinitre);
